import { OnboardingScreenInterests } from '../screens/Interests';

import { OnboardingReplikaAppUsers } from './screens/AppUsers';
import { ScreenEmail } from './screens/Email';
import { ScreenLoneliness } from './screens/Loneliness';
import { ScreenName } from './screens/Name';
import { ScreenPersonalizingFeed } from './screens/PersonalizingFeed';
import { ScreenPreferences } from './screens/Preferences';
import { ScreenSecurity } from './screens/Security';
import { ScreenTopics } from './screens/Topics';
import { LayoutDataType } from './types';

export const layoutSteps = {
  preferences: {
    component: ScreenPreferences,
    images: [],
  },
  interests: {
    component: OnboardingScreenInterests,
    images: [
      'https://d3hhlnlnie19wm.cloudfront.net/web-onb/assets/svg-sprite.svg',
    ],
  },
  appusers: {
    component: OnboardingReplikaAppUsers,
    images: [
      'https://d3hhlnlnie19wm.cloudfront.net/web-onb/assets/onboarding/AppUsers/planet_static.png',
    ],
  },
  topics: {
    component: ScreenTopics,
    images: [],
  },
  security: {
    component: ScreenSecurity,
    images: [],
  },
  name: {
    component: ScreenName,
    images: [],
  },
  loneliness: {
    component: ScreenLoneliness,
    images: [],
  },
  personalizing_feed: {
    component: ScreenPersonalizingFeed,
    images: [],
  },
  email: {
    component: ScreenEmail,
    images: [],
  },
};

export const layoutStepsKeys = Object.keys(layoutSteps);

export const layoutDataDefault: LayoutDataType = {
  name: '',
  categories: [],
  preloadCategories: [],
  characters: [],
  ai_characteristic: 'Neutral',
  interests: [],
  topics: '',
  email: '',
  loneliness: null,
};

// Category constants - not used
// Categories are dynamically loaded from API via useQueryOnboardingCategories hook
// and sent to server on Preferences screen
export const HARDCODED_CATEGORIES = [];
